import styled from 'styled-components';
import {
  companyColor,
  spacing,
  device,
  sidebarSize,
} from 'styles/theme';

export const Box = styled.div.attrs({
  role: 'sidebar',
})`
  display: ${({ isShow }) => (isShow ? 'grid' : 'none')};
  width: min(86vw, ${sidebarSize});
  max-width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  grid-template-rows: max-content auto auto 1fr;
  align-content: start;
  background-color: ${companyColor('background')};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  padding: 64px 16px 20px;
  gap: 24px;
  grid-area: sidebar;
  z-index: 2;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  @media only screen and (${device('tablet')}) {
    padding: 70px 20px 24px;
    gap: 32px;
  }

  @media only screen and (${device('laptop')}) {
    display: grid;
    width: ${sidebarSize};
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    padding: ${spacing('layoutBox')};
    gap: 40px;
  }

`;
